/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TextTemplate
 */
export interface TextTemplate {
    /**
     * 
     * @type {string}
     * @memberof TextTemplate
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TextTemplate
     */
    facility_id: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextTemplate
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof TextTemplate
     */
    type_id: string;
    /**
     * 
     * @type {string}
     * @memberof TextTemplate
     */
    text: string;
}

/**
 * Check if a given object implements the TextTemplate interface.
 */
export function instanceOfTextTemplate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "type_id" in value;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function TextTemplateFromJSON(json: any): TextTemplate {
    return TextTemplateFromJSONTyped(json, false);
}

export function TextTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'facility_id': json['facility_id'],
        'title': json['title'],
        'type_id': json['type_id'],
        'text': json['text'],
    };
}

export function TextTemplateToJSON(value?: TextTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'title': value.title,
        'type_id': value.type_id,
        'text': value.text,
    };
}

